import { Link } from "react-router";
import { useI18n } from "../i18n/I18nProvider";
import { api, imageUrl } from "../lib/api";
import { useStoreSales } from "../lib/CatalogProvider";
import { useMoney } from "../lib/CurrencyProvider";
import { useAsync } from "../lib/useAsync";
import { useGame } from "../lib/GameProvider";

/**
 * The home banner's three cards: the three most expensive cards in stock (priciest in the middle),
 * each linking to its page. Until they load, or with nothing in stock, the plain coloured cards.
 */
export function HeroCards({ variant }: { variant: "hero" | "soon" }) {
  const { pick } = useI18n();
  const { format } = useMoney();
  // Closed, the store's price isn't on sale: just the name.
  const storeSales = useStoreSales();
  const { game } = useGame();
  const showcase = useAsync((signal) => api.showcase(game, signal), [game]);
  const cls = variant === "hero" ? ["hero-card c1", "hero-card c2", "hero-card c3"] : ["soon-card s1", "soon-card s2", "soon-card s3"];
  const cards = showcase.data ?? [];
  // Priciest in the middle (the front card), the next two at the sides.
  const slots = cards.length === 3 ? [cards[1], cards[0], cards[2]] : [];

  if (!slots.length) {
    return (
      <div className={`${variant}-art`} aria-hidden="true">
        {cls.map((c) => (
          <span key={c} className={c} />
        ))}
        {variant === "soon" && (
          <>
            <span className="soon-spark k1" />
            <span className="soon-spark k2" />
            <span className="soon-spark k3" />
          </>
        )}
      </div>
    );
  }
  return (
    <div className={`${variant}-art`}>
      {slots.map((card, i) => (
        <Link key={card.slug} to={`/producto/${card.slug}`} className={`${cls[i]} has-img`} title={storeSales ? `${pick(card.name)} · ${format(card.price)}` : pick(card.name)}>
          <img src={imageUrl(card.imageKey)} alt={pick(card.name)} loading="eager" />
        </Link>
      ))}
    </div>
  );
}
